import { render, staticRenderFns } from "./HomeCurrentProject.vue?vue&type=template&id=f3a6c3ea&"
import script from "./HomeCurrentProject.vue?vue&type=script&lang=js&"
export * from "./HomeCurrentProject.vue?vue&type=script&lang=js&"
import style0 from "./HomeCurrentProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports